import Vue from "vue";
import Vuex from "vuex";

import app from "./app";
import meeting from "./meeting";
import preview from "./preview";
import sequence from "./sequence";

Vue.use(Vuex);

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */

export default function(/* { ssrContext } */) {
  const Store = new Vuex.Store({
    modules: {
      app,
      meeting,
      preview,
      sequence
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: process.env.DEBUGGING
  });

  return Store;
}
